/* istanbul ignore file */
import { array as codecArray, number as codecNumber, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CreateGroupGroupSetDataParser = 
/* #__PURE__ */ parsers.object([
    ['memberIds', /* #__PURE__ */ codecArray(codecNumber), 'member_ids'],
    ['name', /* #__PURE__ */ codecOptional(codecString)],
]);
export class CreateGroupGroupSetData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateGroupGroupSetDataParser.decode(input).map(res => new CreateGroupGroupSetData(res));
    }
    static unsafeDecode(input) {
        return CreateGroupGroupSetData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateGroupGroupSetDataParser.encode(data);
    }
    static schema() {
        return CreateGroupGroupSetDataParser.schema();
    }
}
